<template>
    <v-expansion-panels>
        <v-expansion-panel v-for="(wallType, indexWallType) in wallTypes" :key="wallType.type">
            <v-row no-gutters>
                <v-col cols="8">
                    <v-expansion-panel-title>
                        {{ wallType.type }}
                    </v-expansion-panel-title>
                </v-col>
                <v-col cols="4">
                    <v-radio-group v-model="wallType.selectedOption" class="panel-radio-group" inline
                        @change="handleParentChange(wallType, wallTypes)">
                        <v-radio :label="$t('option') + '1'" :value="1"></v-radio>
                        <v-radio :label="$t('option') + '2'" :value="2"></v-radio>
                        <v-radio :label="$t('option') + '3'" :value="3"></v-radio>
                        <v-radio :label="$t('qwebOption')" :value="4"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-expansion-panel-text>
                <v-row v-for="(panel, index) in wallType.panels" :key="panel.id" no-gutters>
                    <v-col cols="3">
                        <v-btn
                            variant="tonal"
                            density="compact" 
                            @click="selectWallId(panel.id)">
                                {{ $t('wall') }} {{ index + 1 }}
                        </v-btn>
                        {{ totalPanelCount(panel) }}
                    </v-col>
                    <v-col cols="5">
                        <div v-for="(filteredPanel) in filterAllPanelWithCorespondingWall(AllPanelWithCorespondingWall, indexWallType + 1, index + 1)"
                            :key="filteredPanel.id" style="margin: 5px; display: inline-block;"
                            :style="{ width: filteredPanel.width / 4 + 'px', height: filteredPanel.length / 4 + 'px', backgroundColor: isFullPanel(filteredPanel) ? '#C79467' : '#70451F' }">
                        </div>
                    </v-col>
                    <v-col cols="4">
                        <v-radio-group v-model="panel.selectedOption" inline>
                            <v-radio :label="$t('option') + '1'" :value="1"></v-radio>
                            <v-radio :label="$t('option') + '2'" :value="2"></v-radio>
                            <v-radio :label="$t('option') + '3'" :value="3"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script setup>

import {useI18n} from "vue-i18n";

const {t}    = useI18n();

defineProps({
    wallTypes: Array,
    AllPanelWithCorespondingWall: Array,
    length: Number,
    width: Number,
    isFullPanel: Function
});

const emit = defineEmits(['selectWallId', 'handleParentChange']);

function handleParentChange(wallType, wallTypes) {
    emit('handleParentChange', wallType, wallTypes)
}

function selectWallId(wallId) {
    emit('selectWallId', wallId)
}

function filterAllPanelWithCorespondingWall(AllPanelWithCorespondingWall, indexWallType, index) {
    return AllPanelWithCorespondingWall.filter(panel => panel.id.split('-')[0] === indexWallType.toString() && panel.id.split('-')[1] === index.toString());
}

const totalPanelCount = (panel) => {
  const panelRatio = (Math.round(panel.ratio * 100) / 100).toFixed(2);
  const panelRatioCeil = Math.ceil(panelRatio);
  return t('totaling') + ' ' + panelRatio + ' ' + t('panel', panelRatioCeil);
};

</script>

<style scoped>
@import '@/assets/styles/components/panelCountEstimator/PanelizationPropositionList.css';
</style>